import stationSelectionTemplate from 'templates/liveTV/_messageStationsSelection.tpl';
import BaseLiveTVMessage from 'components/messageBoxes/BaseLiveTVMessage';
import TrackingService from 'services/TrackingService';

export default class StationSelectionLiveTVMessage extends BaseLiveTVMessage {
    constructor(parentContainer, data, copy) {
        super(parentContainer, stationSelectionTemplate({ stations: data, title: copy.title }));

        this.onStationSelectedCallback = null;
        this.trackingService = new TrackingService();
    }

    onStationSelected(callback) {
        this.onStationSelectedCallback = callback;
    }

    show() {
        super.show();

        let self = this;
        for (let stationBox of this.me.querySelectorAll('.station__box')) {
            stationBox.addEventListener('click', function (e) {
                self.onStationSelectedCallback(this.dataset.station);
            });
        }
    }
}
